import { Section, Text } from "@react-email/components"

export default function RoundIcon({ character }: { character: string }) {
  return (
    <Section className="bg-listflix-yellow-main rounded-full p-[4px] w-[30px] h-[30px]">
      <Text className="mb-[0px] mt-[0px] text-[18px] leading-[18px] text-white font-bold text-center">{character}</Text>
    </Section>
  )
}